import React, { useMemo } from 'react';
// @ts-ignore
import styles from './PredefinedPhrasesDiscourseSelectionItem.module.scss';
import { PredefineDiscoursePhrase } from '../PredefinedPhrasesDiscourseSetup';
import { getLabel } from '../../../Services/discrousePredifinedPhrase.service';

interface Props {
	item: PredefineDiscoursePhrase;
	onSelect: (item: PredefineDiscoursePhrase) => void;
}

const PredefinedPhrasesDiscourseSelectionItem: React.FC<Props> = ({
	item,
	onSelect,
}) => {
	const label: string | undefined = useMemo(() => {
		return getLabel(item);
	}, [item]);

	if (!label) {
		return <></>;
	}

	return (
		<div className={styles.wrapper} onClick={() => onSelect(item)}>
			{label}
		</div>
	);
};

export default PredefinedPhrasesDiscourseSelectionItem;
